import cloneDeep from 'lodash/cloneDeep';
import Contact from '@/classes/v2/Contact';

const currentUserContacts = state => {
  return cloneDeep(state.currentUserContacts).sort(Contact.compare) || [];
};

const enterpriseContacts = state => {
  return cloneDeep(state.enterpriseContacts).sort(Contact.compare) || [];
};

const allContacts = state => {
  return [
    ...cloneDeep(state.currentUserContacts),
    ...cloneDeep(state.enterpriseContacts)
  ].sort(Contact.compare) || [];
};

const getContactByContactId = state => contactId => {
  const contacts = [...state.currentUserContacts, ...state.enterpriseContacts];
  return cloneDeep(contacts.find(contact => contact.contactId === contactId));
};

const getContactById = state => id => {
  const contacts = [...state.currentUserContacts, ...state.enterpriseContacts];
  return cloneDeep(contacts.find(contact => contact.contactId === id));
};

const getContactByNumber = state => number => {
  const contacts = [...state.currentUserContacts, ...state.enterpriseContacts];
  return cloneDeep(contacts.find(contact => contact.number === number));
};

const findCurrentUserContacts = state => (searchString = '') => {
  const filteredContacts = state.currentUserContacts
    .filter(contact => contact.includes(searchString))
    .sort(Contact.compare);
  return cloneDeep(filteredContacts);
};

const findEnterpriseContacts = state => (searchString = '') => {
  const filteredContacts = state.enterpriseContacts
    .filter(contact => contact.includes(searchString))
    .sort(Contact.compare);
  return cloneDeep(filteredContacts);
};

const findContacts = state => (searchString = '') => {
  const filteredContacts = [...state.currentUserContacts, ...state.enterpriseContacts]
    .filter(contact => contact.includes(searchString))
    .sort(Contact.compare);
  return cloneDeep(filteredContacts);
};

export default {
  allContacts,
  currentUserContacts,
  enterpriseContacts,
  findContacts,
  findCurrentUserContacts,
  findEnterpriseContacts,
  getContactByContactId,
  getContactById,
  getContactByNumber
};
